import * as React from "react";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { SellAction } from "./Action/SellAction";
import { SellInvestment } from "./Components/SellInvestment/SellInvestment";
import { SellOrderSetup } from "./Components/OrderSetup/OrderSetup";
import { Review } from "./Components/Review/Review";
import { SellStepperName } from "./Resource/Content";
import { SellStore } from "./Store/Variable";
import { productMap } from "../SinglePaymentTransferWizard/Resource/Content";
import { BatchInfoModel } from "../../../../../Wrap/Models/Domains/Orders/Batch/BatchInfoModel";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
interface ISellWizardState extends IAccountContextWizardComponentState {
    extraInfo?: any;
}
export class SellWizard extends AccountContextWizardComponent<ISellWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            extraInfo: null,
            clientAccount: null,
            customer: null,
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(SellStore, () => this.onStoreChange());
    }

    onAccountRoleStoreChange(): void {
        super.onAccountRoleStoreChange();
        const { customer } = this.state;
        const accountRole = AccountRoleStore.getAccountRoles()?.find((x) => x.IsPrimary);
        if (accountRole != null) {
            this.setState({
                extraInfo: `${customer.PersonalDetails.Name.Given} ${customer.PersonalDetails.Name.Family}`,
            });
        }
    }

    private onStoreChange() {
        const data = SellStore.getData();
        this.setState({
            isLoading: false,
            data: data,
        });
    }

    componentDidMount() {
        super.componentDidMount();
        SellAction.initSellModel();
    }

    saveInstruction(from, to, toUrl, params, stepLength) {
        const shouldNavigateToImmediately = (
            from === 0 &&
            this.state.data.BatchId && this.state.data.BatchId > 0 &&
            this.state.data.TransId && this.state.data.TransId > 0
        );
        
        if (shouldNavigateToImmediately) {
            this.setState({ onPosting: false });
            Navigator.navigateToAndPreserveQueryParameters(toUrl);
            return;
        }
        
        if (to == -1) {
            this.onExit();
        } else {
            const data: BatchInfoModel = JSON.parse(JSON.stringify(this.state.data));
            data.InvestmentList = [...data.InvestmentList.filter((x) => x.OrderQuantity > 0 || x.OrderValue > 0)];
            SellAction.goToNextStep(from, data, (d) => {
                this.setState({ onPosting: false });
                if (d && d.length > 0) {
                    this.setState({ errorMsg: d.map((ele) => ele.UserMessage), isShowErrorMsg: true });
                } else {
                    Navigator.navigateToAndPreserveQueryParameters(toUrl);
                }
            });
        }
    }

    onExit() {
        // const params = getQueryParameters();
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onCancel() {
        this.onExit();
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        const data = this.state.data as BatchInfoModel;
        data.InvestmentList = [...data.InvestmentList.filter((x) => x.OrderQuantity > 0 || x.OrderValue > 0)];
        SellAction.submit(data, (result) => {
            this.setState({ isSubmitting: false });
            if (!result.SubmissionSucceed) {
                this.setState({
                    active: true,
                    errorMsg: [`There was an error when processing Batch ${result.BatchId}.`],
                });
            }
        });
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);

        this.stepperConfig = [
            {
                title: SellStepperName.orderStep,
                url: Urls.get().SellOrderSetup,
                path: Contents.URLMap.orderSetup,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <SellOrderSetup {...this.getStepProps(0)} type={type} />,
            },
            {
                title: SellStepperName.ist,
                url: Urls.get().SellInvestmentSelection,
                path: Contents.URLMap.ist,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <SellInvestment {...this.getStepProps(1)} type={type} readonly={RestrictionStore.sellDisabled()} />
                ),
            },
            {
                title: SellStepperName.review,
                url: Urls.get().SellReview,
                path: Contents.URLMap.review,
                onSubmit: () => this.onSubmit(),
                needPrint: true,
                canSubmit: () => this.child[2].isValid(),
                component: (
                    <Review
                        {...this.getStepProps(2)}
                        type={type}
                        onClearError={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    />
                ),
            },
            {
                title: SellStepperName.confirmation,
                url: Urls.get().SellConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => {
                            this.state.errorMsg.length > 0 || !checkPermission(UserClaim.AdviserPortalDluOrdersCanView)
                                ? Navigator.navigateToAndPreserveQueryParameters(Urls.get().SellReview)
                                : (window.location.href = `/clients/orders/orders.aspx?claccountid=${
                                      getQueryParameters()["claccountid"]
                                  }`);
                        }}
                        buttonLabel={this.state.errorMsg.length > 0 ? "Previous" : "Go to transactions"}
                        errorMsg={this.state.errorMsg[0]}
                        successMessage={`We've received your instruction to Sell investments for ${
                            this.state.extraInfo
                        } (${getQueryParameters()["claccountid"]}).`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Sell investments";
        processProps.onSave = null;
        processProps.subTitle = productMap[getQueryParameters()["type"]];
        processProps.goBacktoFirst = true;
        return processProps;
    }
}
